import type { AgentBasicsFormValues } from './AgentBasicsStep';
import type { ModelOption } from './AgentModelStep';
import type { PromptOption } from './AgentPromptStep';

interface AgentConfirmStepProps {
    basics: AgentBasicsFormValues;
    selectedModel: ModelOption | null;
    selectedPrompt: PromptOption | null;
}

function SummaryRow({
    label,
    value,
}: {
    label: string;
    value: string | null | undefined;
}) {
    const display = value ?? '—';
    return (
        <div className="flex justify-between gap-4 border-b border-slate-100 py-2 text-sm">
            <span className="font-medium text-slate-500">{label}</span>
            <span className="text-right text-slate-900">
                {display === '—' ? (
                    <span className="text-slate-400">None</span>
                ) : (
                    display
                )}
            </span>
        </div>
    );
}

export function AgentConfirmStep({
    basics,
    selectedModel,
    selectedPrompt,
}: AgentConfirmStepProps) {
    return (
        <div className="w-full space-y-4">
            <h3 className="text-sm font-semibold text-slate-700">
                Summary
            </h3>
            <div className="rounded-lg border border-slate-200 bg-slate-50/50 px-4 py-2">
                <SummaryRow label="Name" value={basics.name} />
                <SummaryRow label="Key" value={basics.key} />
                <SummaryRow label="Description" value={basics.description || undefined} />
                <SummaryRow
                    label="Tags"
                    value={
                        basics.tags.length > 0
                            ? basics.tags.join(', ')
                            : undefined
                    }
                />
                <SummaryRow
                    label="Model"
                    value={selectedModel?.name ?? undefined}
                />
                <SummaryRow
                    label="Prompt"
                    value={selectedPrompt?.name ?? undefined}
                />
            </div>
        </div>
    );
}
